module.exports = __webpack_public_path__ + "entry-150bfe9b/krakenhaus-photo-293d62a5dd7a773267f50744bc722101.webp";